import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda detailu produktu. Zatím obsahuje jen sekci Destinace (převzaté z projektu při založení);
 * další nastavení přibydou později. Otevírá se výběrem uzlu produktu ve stromu.
 */
export const productDetailAgenda = defineAgenda({
  id: 'app.planner.product-detail',
  path: 'app/planner/product-detail',
  open: {
    productId: param.uuid(),
  },
  title: 'Detail produktu',
  icon: 'package',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
